import React, {useState} from 'react';
import {v4 as uuid} from 'uuid';
import {Button, Icon} from '@lightricks/react-design-system';
import useUiInteractionEvent from '@contentlab/hooks/analytics/use-interaction-event';
import useProcessEvent from '@contentlab/hooks/analytics/use-process-event';
import {
  CONTENT_STUDIO_VIEW_NAMES,
  FLOW_NAMES,
} from '@/lib/analytics/analyticsConstants';
import {onFileInput} from './utils';

interface FileUploaderButtonProps {
  buttonLabel: string;
  size?: 'small' | 'medium' | 'large';
  mode?: 'tinted' | 'filled';
  iconAppearance?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'inverse'
    | 'inverse-secondary'
    | 'neutral'
    | 'neutral-secondary'
    | 'brand'
    | 'brand-secondary'
    | 'disabled'
    | 'danger'
    | 'white'
    | 'black';
  iconSize?: 'small' | 'medium' | 'large';
}

function FileUploaderButton({
  buttonLabel,
  size = 'medium',
  mode = 'tinted',
  iconAppearance = 'primary',
  iconSize = 'medium',
}: FileUploaderButtonProps) {
  const {uiInteraction} = useUiInteractionEvent();
  const processEventHandlers = useProcessEvent();
  const [uploadInteractionId, setUploadInteractionId] = useState(uuid());
  return (
    <>
      <Button
        appearance="neutral"
        mode={mode}
        size={size}
        iconPosition="start"
        icon={
          <Icon
            name="Actions-Upload2"
            size={iconSize}
            appearance={iconAppearance}
          />
        }
        onClick={() => {
          uiInteraction({
            item_name: 'upload_file',
            interaction_location: CONTENT_STUDIO_VIEW_NAMES.ASSETS,
            flow_name: FLOW_NAMES.CONTENT_STUDIO.ASSETS,
            interaction_id: uploadInteractionId,
          });
          document.getElementById('file-upload')?.click();
        }}
      >
        {buttonLabel}
      </Button>
      <input
        type="file"
        id="file-upload"
        accept="video/*"
        style={{display: 'none'}}
        multiple
        onChange={async (e) => {
          const selectedFiles = e.target.files;
          if (selectedFiles && selectedFiles.length > 0) {
            await onFileInput(
              Array.from(selectedFiles),
              uploadInteractionId,
              CONTENT_STUDIO_VIEW_NAMES.ASSETS,
              processEventHandlers
            );
            setUploadInteractionId(uuid());
          }
        }}
      />
    </>
  );
}

export default FileUploaderButton;
